module.exports = __webpack_public_path__ + "img/final-fantasy.294c129e.png";